module.exports = require('./dec/decode').BrotliDecompressBuffer;



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/brotli/decompress.js